exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* explorer */\n/* actionbar */\n:host, :host .cat-content-container {\n  width: 100%;\n  height: 100%;\n  padding-left: 50px;\n  position: relative;\n  display: block; }\n  :host .inner, :host .cat-content-container .inner {\n    position: absolute;\n    width: calc(100% - 50px);\n    height: 100%; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_develop@2/app/Resources/Public/src/app/modules/base-app/components/content-container/content-container.component.scss
// module id = ../../../../../src/app/modules/base-app/components/content-container/content-container.component.scss
// module chunks = main